export default function navigation() {
	const body = document.querySelector('body');
	const hamburger = document.querySelector('button.hamburger');
	const header = document.querySelector('header.header-navigation');
	const backToTopIcon = document.querySelector('nav.back-to-top');
	const searchTriggerButtons = document.querySelectorAll(
		'span.header-navigation__search-trigger'
	);
	const searchBar = document.querySelector('div.search-bar');
	const searchInput = document.querySelector('input[type="search"]');
	const newsletterTrigger = document.querySelector('span.newsletter__btn');
	const newsletterDropdown = document.querySelector(
		'div.newsletter__dropdown'
	);
	const mobileTrigger = document.querySelectorAll('.mobile-menu__mobile .menu-item-has-children > a.menu-item__link')

	// This function is responsible for displaying the mobile menu when the hamburger is clicked
	const showMobileMenu = () => {
		if (
			hamburger instanceof window.HTMLElement &&
			body instanceof window.HTMLElement
		) {
			hamburger.addEventListener('click', () => {
				hamburger.classList.toggle('is-active');
				body.classList.toggle('navigation-active');

				document.querySelectorAll('.menu-item-has-children--open').forEach((el) => {
					el.classList.remove('menu-item-has-children--open');
				});
			});
		}
	};

	// Used to detect when the header is sticky so that additional styling can be applied.
	const sticky = () => {
		if (header instanceof window.HTMLElement) {
			window.addEventListener('scroll', () => {
				body.classList.toggle('header--scrolling', window.scrollY > 0);
			});
		}
	};

	// This function is responsible for the back to the top functionality
	const scrollBackToTop = () => {
		if (backToTopIcon instanceof window.HTMLElement) {
			backToTopIcon.addEventListener('click', () => {
				window.scrollTo({top: 0, behavior: 'smooth'});
			});
		}
	};

	// This functionality is responsible for smooth scrolling when clicking on anchor links
	const smoothScroll = () => {
		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener('click', (e) => {
				e.preventDefault();

				document
					.querySelector(anchor.getAttribute('href'))
					.scrollIntoView({
						behavior: 'smooth',
					});
			});
		});
	};

	// This functionality is responsible for the search form dropdown.
	const dropdown = () => {
		if (
			searchBar instanceof window.HTMLElement &&
			searchInput instanceof window.HTMLElement
		) {
			searchTriggerButtons.forEach((el) => {
				el.addEventListener('click', () => {
					searchInput.focus();
					searchBar.classList.toggle('search-bar--active');
					el.classList.toggle(
						'header-navigation__search-trigger--active'
					);
				});
			});
		}
	};

	// This functionality is responsible for the subscription dropdown.
	const subscription = () => {
		if (
			newsletterTrigger instanceof window.HTMLElement &&
			newsletterDropdown instanceof window.HTMLElement
		) {
			newsletterTrigger.addEventListener('click', () => {
				newsletterDropdown.classList.toggle(
					'newsletter__dropdown--open'
				);
			});
		}
	};


	const mobileMenu = () => {
		mobileTrigger.forEach((el) => {
			el.addEventListener('click', (e) => {
				e.preventDefault();
				el.parentNode.classList.toggle(
					'menu-item-has-children--open'
				);
			})
		});
		document.querySelectorAll('li.back.menu-item').forEach((bk) => {
			bk.addEventListener('click', (e) => {
				e.preventDefault();
				document.querySelectorAll('.menu-item-has-children--open').forEach((bk) => {
					bk.classList.remove('menu-item-has-children--open')
				})
			})
		})


	}

	// Initialize the navigation functionalities
	showMobileMenu();
	sticky();
	scrollBackToTop();
	// smoothScroll();
	dropdown();
	subscription();
	mobileMenu();
}
